import React from 'react';

export const DoneLoadingIndicator: React.FunctionComponent = () => (
  <div data-testid="doneLoadingSpinner" className="width-0 height-0" />
);
